import { HOURS, HOUR_HEIGHT_PX } from "../../utils/time-constants";

export function WeekGridHoursColumn() {
  return (
    <div className="relative border-r border-border/10">
      {HOURS.map((hour) => (
        <div
          key={hour}
          className="flex items-start justify-end pr-3"
          style={{ height: `${HOUR_HEIGHT_PX}px` }}
        >
          <span
            className={`text-[10px] text-ink-faint/60 tabular-nums ${hour === 0 ? "mt-1" : "-mt-1.5"}`}
          >
            {String(hour).padStart(2, "0")}:00
          </span>
        </div>
      ))}
    </div>
  );
}
